const gql = (params) => {
    const operation = params.operation;
    const queryType = params.type;
    const getData = params.getData;
    const variables = params.variables;
    let queryStr = queryType + ' ' + operation + ' { ' + operation;

    if(Object.keys(variables).length > 0) {
        queryStr += '( ';
        for (let key in variables) {
            // if(typeof variables[key] === 'boolean' || typeof variables[key] === 'number') {
            //     queryStr += key + ': ' + variables[key] + ' ';
            // }
            if(typeof variables[key] === 'string') {
                // 특수 문자 이스케이프 처리
                const escapedValue = variables[key]
                    .replace(/\\/g, '\\\\')  // 백슬래시
                    .replace(/"/g, '\\"')     // 따옴표
                    .replace(/\n/g, '\\n')    // 줄바꿈
                    .replace(/\r/g, '\\r')    // 캐리지 리턴
                    .replace(/\t/g, '\\t');   // 탭
                queryStr += key + ': "' + escapedValue + '" ';
            }
            else if (typeof variables[key] === 'object') {

                let jsonStr = JSON.stringify(variables[key]);
                // GraphQL 객체 리터럴 형식으로 변환: "key": → key:
                // 식별자 패턴으로 한정하여 문자열 값 안의 \"key\": 가 오인 매칭되는 것을 방지
                // (이전 정규식이 \"@context\": 같은 이스케이프된 키를 매칭하면서
                //  결과에 \@ 가 남아 GraphQL 파서가 "Invalid character escape sequence: \@" 로 거부했음)
                jsonStr = jsonStr.replace(/"([a-zA-Z_$][a-zA-Z0-9_$]*)":/g, "$1:");

                queryStr += key + ': ' + jsonStr + ' ';
            }
            else {
                queryStr += key + ': ' + variables[key] + ' ';
            }

        }
        queryStr += ') '

    }
    queryStr += ' {' + getData + '}}';

    const gpqParams = {
        operationName: operation,
        query: queryStr,
        variables: {}
    };

    return gpqParams;
};
export default gql;
